import React from 'react';
import Accordion from 'react-bootstrap/Accordion';
import eticaitems from '../../json/eticaitems';
import './etica.css';

function Etica() {
  return (
    
    <div
        className="container-full-width cinterno-bg"
        style={{
        backgroundImage: `url(${eticaitems.background})`,
        backgroundSize: "15%",
        backgroundPosition: "center",
        backgroundRepeat: "repeat",
        width: "100%",
        minHeight: "100vh"
        }}
        >

      {/* 🔹 HEADER */}
      <div className='row'> 
        <div 
         className="fixed-header"
         style={{ backgroundColor: "transparent" }}
         >
        <h3 className='title'>{eticaitems.titulo}</h3>
        <hr className='hr-gob' />
        </div>
      </div>

      {/* 🔹 ICONOS */}
      <div className="icon-section">

        {eticaitems.iconos.map((item) => (
          <a
            key={item.id}
            href={item.ruta}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              textDecoration: 'none',
            }}
          >
            <i className={item.icono} style={{ fontSize: '40px' }}></i>
            <span style={{ marginTop: '8px', color: '#691B31' }}>
              <b>{item.texto}</b>
            </span>
          </a>
        ))}

      </div>

      {/* 🔹 ACORDEÓN */}
      <div className="accordion-container">
        <Accordion>

          {eticaitems.secciones.map((seccion) => (
            <Accordion.Item
              key={seccion.id}
              eventKey={seccion.id.toString()}
              className={`accordion-CONTR${seccion.id}`}
            >

              <Accordion.Header>
                {seccion.titulo}
              </Accordion.Header>

              {seccion.items.map((item, index) => (
                <Accordion.Body key={index}>

                  {item.texto}

                  <a
                    href={item.ruta}
                    target={item.externo ? "_blank" : "_self"}
                    rel="noopener noreferrer"
                  >
                    <button style={{ fontSize: "10px", padding: "3px 7px" }}>
                      PDF
                    </button>
                  </a>

                </Accordion.Body>
              ))}

            </Accordion.Item>
          ))}

        </Accordion>
      </div>

    </div>
  );
}

export default Etica;